export default __webpack_public_path__ + "static/media/crazy6_V2.2990a50a.gif";